<template>
    <v-flex
        md12
        class="px-12 pb-12"
    >
        <PageHeader
            :breadcrumbs="breadcrumbs"
            :title="$t('page.course_new.title')"
            back
        />
        <v-row>
            <v-col cols="12">
                <CourseForm
                    :data="data"
                    :raw-data="rawData"
                    :errors="formErrors"
                    :save-function="saveObject"
                    :discard-function="resetObject"
                />
            </v-col>
        </v-row>
    </v-flex>
</template>

<script>

import PageHeader from '@/components/common/PageHeader';
import CourseForm from '@/components/courses/Form/CourseForm';
import CourseProxy from '@/proxies/CourseProxy';
import CourseMixin from '@/mixins/course';
import { StandBy, SuccessSnackbar } from '@/app-events.js';

export default {
    name: 'RavNew',
    mixins: [ CourseMixin ],
    components: {
        PageHeader,
        CourseForm,
    },
    data() {
        return {
            breadcrumbs: [
                {
                    text: this.$t('page.home.title'),
                    exact: true,
                    to: { name: 'home' },
                },
                {
                    text: this.$t('page.course.title'),
                    exact: true,
                    to: { name: 'course' },
                },
                {
                    text: this.$t('general.new'),
                    disabled: true,
                },
            ],
            data: {
                amm: {}
            },
            rawData: {},
        };
    },
    methods: {
        saveObject() {
            if (JSON.stringify(this.data) === JSON.stringify(this.rawData)) {
                return;
            }
            this.$eventBus.dispatch(new StandBy(true));
            new CourseProxy().new(this.prepareFormData(this.data)).then(({ data }) => {
                this.$eventBus.dispatch(new StandBy(false));
                this.$eventBus.dispatch(new SuccessSnackbar(data.data.has_holidays ? this.$t('course.actions.created_with_holidays') : this.$t('course.actions.created')));
                this.$router.push({ name: 'course_detail', params: { id: data.data.id } });
            }).catch(({ data }) => {
                this.processErrors(data);
                this.$eventBus.dispatch(new StandBy(false));
            });
        }
    },
};
</script>
